import { Component } from "react";

export default class QrErrorBoundary extends Component {
  state = { error: false };

  static getDerivedStateFromError() {
    return { error: true };
  }

  componentDidCatch(error) {
    console.warn("[Expo Go QR]", error);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="text-[11px] text-white/45 max-w-[140px] leading-relaxed">
          QR preview unavailable. Use Open Snack instead.
        </div>
      );
    }
    return this.props.children;
  }
}
